import { FC, useCallback } from 'react'
import { Analytics } from '@core/services/mixpanel'
import { useCustomTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import {
    CalloutContent,
    CalloutText,
    CalloutWrapper,
    IconBadge,
    OpenChatButton,
} from './ChatCallout.styles'
import { ChatCalloutProps } from './ChatCallout.types'
import ChatIcon from '@/assets/images/chat-icon.svg?react'

const ChatCallout: FC<ChatCalloutProps> = ({ issue }) => {
    const theme = useCustomTheme()
    const { id: issueId, issue_type: issueType, name: issueName } = issue

    const handleOpenChat = useCallback(() => {
        Analytics.event('SEM::user_opened_chat_from_issue_drawer', {
            issueId,
            issueType,
            issueName,
        })
        window.Intercom(
            'showNewMessage',
            `Hi, I need help resolving the issue: ${issueName}`
        )
    }, [issueId, issueType, issueName])

    return (
        <CalloutWrapper data-testid="chat-callout">
            <CalloutContent>
                <IconBadge data-testid="chat-callout-icon">
                    <ChatIcon />
                </IconBadge>
                <CalloutText>
                    <Typography
                        variant="xs-semibold"
                        color={theme.colors.greys[800]}
                        noWrap={false}
                    >
                        Stuck on this? Talk with a Cyber Advisor
                    </Typography>
                    <Typography
                        variant="xs-regular"
                        color={theme.colors.greys[500]}
                        noWrap={false}
                    >
                        Chat with our team for help resolving this issue
                    </Typography>
                </CalloutText>
            </CalloutContent>
            <OpenChatButton
                type="button"
                onClick={handleOpenChat}
                data-testid="chat-callout-open-chat"
            >
                <Typography variant="xs-bold" color="inherit">
                    Open Chat →
                </Typography>
            </OpenChatButton>
        </CalloutWrapper>
    )
}

export default ChatCallout
